var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgHisunSecondaryLogo(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlSpace: "preserve",
    width: "67.209mm",
    height: "16.5775mm",
    style: {
      shapeRendering: "geometricPrecision",
      textRendering: "geometricPrecision",
      imageRendering: "optimizeQuality",
      fillRule: "evenodd",
      clipRule: "evenodd"
    },
    viewBox: "0 0 12672.54 3125.76",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "\\u0421\\u043B\\u043E\\u0439_x0020_1"
  }, /*#__PURE__*/React.createElement("metadata", {
    id: "CorelCorpID_0Corel-Layer"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    fill: "#201E1E",
    d: "M9702.73 138.4l0 2873.23c0,103.57 8.77,107.82 110.49,107.82 1101.8,0 969.9,67.71 967.19,-240.16 -1.94,-223.12 -14.48,-971 10.8,-1099.87 87.36,7.9 52.93,18.93 160.12,160.72 55.43,73.39 86.34,111.7 142.11,188.97l584.84 785.38c248.82,253.57 491.6,204.96 875.21,204.96 112.25,0 108.06,-21.95 108.06,-129.91 0,-702.02 27.83,-2349.27 -5.15,-2943.95 -123.54,-46.06 -901.89,-27.55 -1043.93,-12.31l-13.03 1289.05c-98.71,3.58 -211.03,-204.2 -313.36,-336.34 -301.18,-389.01 -621.87,-955.39 -1052.94,-955.39 -453.45,0 -530.42,-48.48 -530.42,107.82z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    fill: "#201E1E",
    d: "M6489.77 182.6l0 2674.32c0,177.92 72.48,254.13 251.32,254.13l1734.98 0c649.34,0 953.1,-487.73 953.1,-1138.23l0 -1768.15c0,-138.96 4.22,-182.29 -146.39,-182.29l-752.14 0c-125.65,0 -148.54,14.59 -148.54,138.12l0 1480.83c0,584.59 4.64,544.36 -690.64,544.36 -133.16,0 -153.35,16.54 -159.44,-121.35 -19.67,-444.89 44.08,-1760.15 -11.88,-2023.94 -278.83,-44.39 -583.56,-18.76 -867.48,-18.01 -138.25,0 -162.89,19.61 -162.89,160.21z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0 str0",
    fill: "#201E1E",
    d: "M4826.46 2171.77c-5.47,3.53 -14.22,0.74 -17.67,8.32l-57.09 17.78c-253.12,40.52 -1361.98,-79.83 -1404.92,48.8 -33.73,101.07 -16.54,776.07 -6.69,850.68 178.9,30.66 2093.78,9.48 2450.62,11.05 332.95,1.47 454.34,-42.88 456.15,-383.12 3.56,-671.76 -4.02,-448.36 -371.36,-837.05l-650.38 -587.01c-95.58,-81.27 -402.45,-334.89 -439.35,-411.35 44.89,-27.32 106.63,-29.23 164.34,-29.17 221.36,0.25 1219.55,33.39 1277.02,-17.86l15.18 -799.66c-117.07,-47.99 -2035.05,-16.84 -2440.8,-18.12 -325.37,-1 -470.5,8.96 -470.33,356.01 0.36,613.44 -11.73,423.4 406.67,815.82l540.94 474.91c47.97,42.2 76.33,55.68 122.77,98.93 85.43,79.63 390.4,325.65 424.89,401.04z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil0",
    fill: "#201E1E",
    d: "M0.41 3106.3c206.64,3.05 854.23,1.47 1072.1,-1.87l6.15 -1094.9c188.33,-0.83 726.78,-3.54 830.75,0.75l5.39 1096.37 1054.75 -1.4 -7.33 -2048.58c-414.99,-7.05 -1535.09,-0.66 -1874.7,-0.41l-11.31 -1048.19c-98.71,-11.77 -1076.25,-8.33 -1076.19,-4.19 0.4,28.43 2.41,2815.11 0.4,3102.41z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "fil1",
    fill: "#ED3237",
    d: "M1908.47 136.34l6.84 695.56 1052.83 -2.75c20.57,-190.93 8.33,-510.04 8.05,-715.11 0,-85.98 14.86,-106.01 -72.52,-106.01l-892.11 0c-98.8,0 -103.1,32.9 -103.1,128.31z"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHisunSecondaryLogo);
export default ForwardRef;